import { ACTIVE_ITEM_SCROLL_VISIBILITY_PADDING_PX } from "./constants";

interface ScrollActiveOptionIntoViewInput {
  optionsContainer: HTMLDivElement;
  activeItem: HTMLDivElement;
  effectiveActiveIndex: number;
  optionsLength: number;
}

interface ActiveOptionScrollDeltaInput {
  activeRect: DOMRect;
  visibleTop: number;
  visibleBottom: number;
}

function resolveActiveOptionScrollDelta({
  activeRect,
  visibleTop,
  visibleBottom,
}: ActiveOptionScrollDeltaInput): number {
  if (activeRect.bottom > visibleBottom) {
    return activeRect.bottom - visibleBottom;
  }

  if (activeRect.top < visibleTop) {
    return activeRect.top - visibleTop;
  }

  return 0;
}

function getVisibleScrollBounds(optionsContainer: HTMLDivElement): {
  visibleTop: number;
  visibleBottom: number;
} {
  const containerRect = optionsContainer.getBoundingClientRect();
  return {
    visibleTop: containerRect.top + ACTIVE_ITEM_SCROLL_VISIBILITY_PADDING_PX,
    visibleBottom:
      containerRect.bottom - ACTIVE_ITEM_SCROLL_VISIBILITY_PADDING_PX,
  };
}

export function scrollActiveOptionIntoView({
  optionsContainer,
  activeItem,
  effectiveActiveIndex,
  optionsLength,
}: ScrollActiveOptionIntoViewInput): void {
  if (effectiveActiveIndex === 0) {
    optionsContainer.scrollTop = 0;
    return;
  }

  if (effectiveActiveIndex === optionsLength - 1) {
    optionsContainer.scrollTop = optionsContainer.scrollHeight;
    return;
  }

  const { visibleTop, visibleBottom } =
    getVisibleScrollBounds(optionsContainer);
  const scrollDelta = resolveActiveOptionScrollDelta({
    activeRect: activeItem.getBoundingClientRect(),
    visibleTop,
    visibleBottom,
  });

  if (scrollDelta === 0) {
    return;
  }

  optionsContainer.scrollTop += scrollDelta;
}
